import type { BatchRow } from './types';

const COLUMNS: (keyof BatchRow)[] = [
	'fileName',
	'score',
	'grade',
	'critical',
	'warning',
	'info',
	'stats',
	'citations',
	'structure',
	'language',
	'provenance',
	'access'
];

function esc(value: string | number): string {
	const s = String(value);
	return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function batchToCsv(rows: BatchRow[]): string {
	const header = COLUMNS.join(',');
	const lines = rows.map((row) => COLUMNS.map((c) => esc(row[c])).join(','));
	return [header, ...lines].join('\n');
}

export function batchToJson(rows: BatchRow[], meta: { id?: string; date?: string } = {}): string {
	return JSON.stringify(
		{
			generatedAt: new Date().toISOString(),
			batchId: meta.id ?? null,
			date: meta.date ?? null,
			count: rows.length,
			rows
		},
		null,
		2
	);
}
